module.exports = __webpack_public_path__ + "img/rep-kim.3716c4eb.png";